export var EPlatformType;
(function (EPlatformType) {
    EPlatformType[EPlatformType["None"] = 0] = "None";
    EPlatformType[EPlatformType["Web"] = 1] = "Web";
    EPlatformType[EPlatformType["WX"] = 2] = "WX";
    EPlatformType[EPlatformType["QQ"] = 3] = "QQ";
    EPlatformType[EPlatformType["BD"] = 4] = "BD";
    EPlatformType[EPlatformType["Oppo"] = 5] = "Oppo";
    EPlatformType[EPlatformType["Vivo"] = 6] = "Vivo";
    EPlatformType[EPlatformType["TT"] = 7] = "TT";
    EPlatformType[EPlatformType["QTT"] = 8] = "QTT";
    EPlatformType[EPlatformType["Native_IOS"] = 9] = "Native_IOS";
    EPlatformType[EPlatformType["KS"] = 10] = "KS";
    EPlatformType[EPlatformType["HW"] = 11] = "HW";
    EPlatformType[EPlatformType["Native_Android"] = 12] = "Native_Android";
    EPlatformType[EPlatformType["Native_Android_233"] = 13] = "Native_Android_233";
    EPlatformType[EPlatformType["Web4399"] = 14] = "Web4399";
    EPlatformType[EPlatformType["Gamebox4399"] = 15] = "Gamebox4399";
})(EPlatformType || (EPlatformType = {}));
